import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../slices/mainSlice';
import Utility from '../../Utility/Utility';
import { forgotPasswordApi } from '../Controller/LoginController';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const language = useSelector((state) => {
        return state.language.language
    });
    const [email, setEmail] = useState(Cookies.get('email') || '');
    const [emailError, setEmailError] = useState('');


    const validateForgotPassword = () => {
        let valid = true;
        if (email.trim() === "") {
            valid = false;
            setEmailError(t('requiredField'));
        } else {
            const emailRegex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!emailRegex.test(email)) {
                valid = false;
                setEmailError(t('invalidEmail'));
            } else {
                setEmailError('');
            }
        }
        return valid;
    }
    const handleForgotPassword = () => {
        let valid = validateForgotPassword();
        if (valid) {
            dispatch(loaderStateTrue());
            let data = {
                email: email
            }
            forgotPasswordApi(data).then((response) => {
                console.log(response);
                if (response.status) {
                    dispatch(loaderStateFalse());

                } else {
                    dispatch(loaderStateFalse());
                    Utility.toastNotifications(response?.message, 'Error', 'error');
                }
            }).catch((error) => {
                console.log(error);
                if (error?.response?.status && error?.response?.status == 401) {
                    Utility.toastNotifications(error?.response?.data?.message, 'Error', 'error');
                }
                dispatch(loaderStateFalse());
            });

        }

    }

    return (
        <div className="lg:p-10 px-5 pt-10 pb-5">
            <div className="flex flex-wrap gap-y-10">
                <div className="lg:w-1/2 w-full">
                    <div className="h-full p-5 relative">
                        <div className="rounded-xl absolute inset-0 bg-[#eaede8] overflow-hidden">
                            <div className="w-[22vw] h-[17vw] rounded-[50%] bg-[#0198FF] blur-[70px] absolute -top-[1vw] right-0 -rotate-[37deg] opacity-80"></div>
                            <div className="w-[30vw] h-[18vw] rounded-[50%] bg-[#FB4A4A] blur-[130px] absolute -top-[2vw] left-0 rotate-[50deg]"></div>
                        </div>
                        <div className="relative flex flex-col gap-y-10">
                            <div className="lg:-mt-16 -mt-10">
                                <img src={require("../../assets/images/star-players.png")} alt="" />
                            </div>
                            <div className="lg:p-5 [&_h1_strong]:bg-gradient-to-r [&_h1_strong]:from-primary-950 [&_h1_strong]:to-primary-500 [&_h1_strong]:bg-clip-text [&_h1_strong]:text-transparent space-y-5">
                                <h1 className="2xl:text-6xl xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-extrabold uppercase text-gray-900">
                                    {t('oneTeam')},<br />{t('oneDream')}<br /><strong>{t('letsDreamTogether')}</strong>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="lg:w-1/2 w-full">
                    <div className="rounded-xl h-full lg:px-10 relative space-y-8 flex flex-col justify-center">
                        <div className="[&_h2_strong]:text-gray-400 space-y-5">
                            <h2 className="xl:text-4xl lg:text-3xl md:text-2xl text-xl font-extrabold leading-[1.2] uppercase">
                                {t('forgotPasswordTitle')} <strong>{t('forgotPasswordSubtitle')}</strong>
                            </h2>
                        </div>

                        <div className="space-y-5">
                            <div>
                                <input type="email" id="email" placeholder={t('email')} className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} />
                            </div>

                            <button className="w-full btn btn-primary" onClick={handleForgotPassword}>{t('resetPassword')}</button>

                            <p className="mt-2 font-secondary font-semibold">
                                <Link to="../login" className="text-primary-500 font-medium hover:underline flex items-center gap-1">
                                    <img src={require("../../assets/images/icons/arrow-left.svg")} alt="" /> {t('backToLogin')}
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
